// The customer workbook for the current sizing (story 75), from the step footers: the filled one at
// the review, the blank template at use case selection. Built from the store's live sizing, so the
// filled one can never disagree with what the ROI summary shows.

import { buildUseCaseWorkbook, useCaseWorkbookFilename as workbookFilename } from '../../engine/xlsx-use-case-workbook';
import { settingsDateStr } from '../../engine/sizing-transfer';
import { customerNameOf } from '../../state/load-paths';
import { sizingOf, useCalculatorStore } from '../../state/calculator-store';
import { XLSX_MIME } from '../../xlsx/writer';

export function downloadWorkbook({ blank = false }: { blank?: boolean } = {}): void {
  const state = useCalculatorStore.getState();
  if (!state.selected.length) return;
  const now = new Date();
  const customerName = customerNameOf(state.account);
  const bytes = buildUseCaseWorkbook({ customerName, calculator: sizingOf(state), generatedAt: now, blank });
  const url = URL.createObjectURL(new Blob([bytes], { type: XLSX_MIME }));
  const a = document.createElement('a');
  a.href = url;
  a.download = workbookFilename(customerName, settingsDateStr(now), blank);
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 3000);
}
